import { Box, styled } from '@mui/material';

const Container = styled(Box)`
  top: var(--header-height);
  left: 0;
  width: 100%;
  height: calc(100vh - var(--header-height));
  padding: 1.5rem;
  background-color: #efefef;
  overflow-y: auto;
  :root {
    font-size: 50vw;
  }
`;
const Section = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-bottom: 1.1rem;
  & > *:not(:last-child) {
    margin-bottom: 1.1rem;
  }
`;

const Infos = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  @media (orientation: landscape) {
    width: 50%;
  }
`;

export { Container, Section, Infos };
